import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { useMutation } from "@tanstack/react-query";

export function useEventAttendanceReportCsv({
  api,
  tz,
}: {
  api: ApiType;
  tz: string;
}) {
  return useMutation({
    mutationFn: async ({
      startDate,
      endDate,
      gt,
      lt,
      eq,
      membership,
    }: {
      startDate?: string;
      endDate?: string;
      gt?: number;
      lt?: number;
      eq?: number;
      membership?: number[];
    }) => {
      const utcStart = zonedTimeToUtc(startDate as string, tz);
      const utcEnd = zonedTimeToUtc(endDate as string, tz);
      return (
        await api.memberApi.eventAttendanceCsv({
          dateFrom: utcStart,
          dateTo: utcEnd,
          gt,
          lt,
          eq,
          membership,
        })
      ).data;
    },
  });
}
